var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Manual Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "To-Do",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-Landing-/-Bank---Ability-to-Assign",
    transform: "translate(-612.000000, -418.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(288.613530, 413.229800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manual-Icon",
    transform: "translate(324.303403, 5.702615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create",
    fill: "#F0CEA4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.519224628,5.5558894 L3.38775736,8.42444798 L0.45444414,8.93816991 C0.432170195,8.94207173 0.40979289,8.94398388 0.387570624,8.94398388 C0.28570996,8.94398388 0.186846718,8.90377708 0.113539081,8.83046944 C0.0242365813,8.74116694 -0.0159702156,8.61395739 0.0058127727,8.48956438 L0.0058127727,8.48956438 L0.519224628,5.5558894 Z M7.81254637,1.67957692 L8.83009357,2.69714997 C8.98146338,2.84851978 8.98146338,3.09392077 8.83011941,3.24529058 L8.83011941,3.24529058 L4.06752613,8.00788386 L2.77586986,6.71625343 L7.81254637,1.67957692 Z M5.69833035,0.113527354 C5.84970016,-0.0378424512 6.09512699,-0.0378424512 6.24647096,0.113527354 L6.24647096,0.113527354 L7.26440576,1.13143632 L2.22772926,6.16811282 L0.93573707,4.87612063 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-(3)",
    transform: "translate(5.028711, 1.512106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6098398,5.42334095 C5.55004827,5.42334095 6.43580639,5.7969549 7.10396199,6.4753787 C7.76884552,7.15047618 8.13501142,8.04160341 8.13501142,8.98466817 C8.13501142,9.13442469 8.01360089,9.25583521 7.86384437,9.25583521 L7.86384437,9.25583521 L0.271167047,9.25583521 C0.121410526,9.25583521 0,9.13442469 0,8.98466817 C0,8.04160341 0.366165903,7.15047618 1.03104942,6.4753787 C1.69920503,5.7969549 2.58498123,5.42334095 3.52517161,5.42334095 L3.52517161,5.42334095 Z M4.06750571,0 C5.4131993,0 6.50800913,1.09480984 6.50800913,2.44050343 C6.50800913,3.78619701 5.4131993,4.88100685 4.06750571,4.88100685 C2.72181212,4.88100685 1.62700228,3.78619701 1.62700228,2.44050343 C1.62700228,1.09480984 2.72181212,0 4.06750571,0 Z",
    id: "Combined-Shape",
    stroke: "#627A98",
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6098398,5.42334095 C5.55004827,5.42334095 6.43580639,5.7969549 7.10396199,6.4753787 C7.76884552,7.15047618 8.13501142,8.04160341 8.13501142,8.98466817 C8.13501142,9.13442469 8.01360089,9.25583521 7.86384437,9.25583521 L7.86384437,9.25583521 L0.271167047,9.25583521 C0.121410526,9.25583521 0,9.13442469 0,8.98466817 C0,8.04160341 0.366165903,7.15047618 1.03104942,6.4753787 C1.69920503,5.7969549 2.58498123,5.42334095 3.52517161,5.42334095 L3.52517161,5.42334095 Z M4.06750571,2.84217094e-14 C5.4131993,2.84217094e-14 6.50800913,1.09480984 6.50800913,2.44050343 C6.50800913,3.78619701 5.4131993,4.88100685 4.06750571,4.88100685 C2.72181212,4.88100685 1.62700228,3.78619701 1.62700228,2.44050343 C1.62700228,1.09480984 2.72181212,2.84217094e-14 4.06750571,2.84217094e-14 Z",
    id: "Combined-Shape",
    fill: "#F0CEA4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manual-icon.cfc2e10010e8b76076ebfae5711d769f.svg";
export { ForwardRef as ReactComponent };